<template>
    <div id="v-submit-wrap">
        <!-- 顶部栏 -->
        <div class="head">
            <dl>
                <dt>
                    <img class="logo" :src="$config.resource + 'dhl_logo.png'" alt="">
                </dt>
                <!-- 头像信息 -->
                <dd>
                    <div class="portrait">
                        <img class="pic" :src="user.head" alt="">
                    </div>
                    <p>{{user.company_name}}</p>
                    <div class="quit" @click="onQuit">
                        <img class="icon" :src="$config.resource + 'tc.png'" alt="">
                    </div>
                </dd>
            </dl>
        </div>
        <!-- 主要部分 -->
        <div class="main_box">
            <!-- 步骤 -->
            <div class="step">
                <img class="pic_bg" :src="$config.resource + 'db_bjt.png'" alt="">
                <div class="row_box">
                    <div class="row curr">
                        <div class="circle">1</div>
                        <p>选择供应商类型</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">2</div>
                        <p>企业概况</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">3</div>
                        <p>工厂概况</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">4</div>
                        <p>产品概况</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">5</div>
                        <p>提交</p>
                    </div>
                </div>
            </div>
            <div class="alike">
                <!-- 生成文档下载 -->
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>生成文档下载</p>
                </div>
                <dl>
                    <dt @click="onDown">
                        <img class="icon" :src="$config.resource + 'xzwj.png'" alt="">
                        <p>文档下载</p>
                    </dt>
                </dl>
                <!-- 文档上传 -->
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>文档上传</p>
                    <div class="remark">
                        <em>备注：{{v.contont}}</em>
                        <samp @click="onReference(1)" v-if="!isRefer">点击展开查看参考</samp>
                        <samp @click="onReference(2)" v-if="isRefer">点击关闭参考</samp>
                    </div>
                </div>
                <dl>
                    <dt>
                        <!-- 未上传 -->
                        <div class="put_box" v-if="supplier_info==''">
                            <img class="put" :src="$config.resource + 'scwj.png'" alt="">
                            <p>文档上传</p>
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="uploadFile($event)" 
                                ref="inputer" 
                                accept=".pdf" 
                            />
                        </div>
                        <!-- 已上传 -->
                        <div class="put_box" v-if="supplier_info!=''">
                            <img class="put" :src="$config.resource + 'ysc.png'" alt="">
                            <p>已上传</p>
                            <!-- 删除 -->
                            <img @click="onDelete" v-if="isType!=2" class="delete" :src="$config.resource + 'sc.png'" alt="">
                        </div>
                    </dt>
                    <dd v-if="isRefer">
                        <img class="pic" :src="v.src" alt="">
                    </dd>
                </dl>
            </div>
            <!-- 按钮 -->
            <div class="btn_box">
                <div class="btn gray" @click="onBack">上一步</div>
                <div class="btn red" v-if="isType!=2&&isReturn==false" @click="onOubmit">提交初审</div>
                <div class="btn red" v-if="isType==2" @click="toViewPage('/knowledge',{type:2})">下一步</div>
                <div class="btn red" v-if="isReturn==true" @click="toViewPage('/')">返回首页</div>
            </div>
        </div>
        <!-- 弹窗 -->
        <div class="popup" v-if="isPopup">
            <div class="Masked"></div>
            <div class="hint">
                <img class="pic" :src="$config.resource + 'tjcg.png'" alt="">
                <img class="icon" @click="onShut" :src="$config.resource + 'gb.png'" alt="">
            </div>
        </div>
    </div>
</template>
<script>
    import store from '../vuex/store.js';
    export default {
        data(){
            return{
                user:'',// 用户信息
                isType:'',// 1.提交下一步 2.详情下一步 3.重新提交

                isRefer:false,// 参考
                isPopup:false,// 提示弹窗
                isReturn:false,// 提交完成
                supplier_info:'',// 上传文档
                v:'',// 参考及备注
            }
        },
        store,
        methods: {
            //页面跳转
            toViewPage($path,$query) {
                this.$jump.toViewPage(this,$path,$query)
            },
            // 参考
            onReference(i){
                if(i==1){
                   this.isRefer = true 
                }else{
                    this.isRefer = false 
                }
            },
            // 上一步
            onBack(){
                this.$router.go(-1);
            },
            // 提交
            onOubmit(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.firstTrial,
                    data: {
                        supplier_info:that.supplier_info
                    },
                    success(res) {
                       that.isPopup = true
                       that.isReturn = true
                    }
                })
            },
            // 关闭弹窗
            onShut(){
                this.isPopup = false
                this.$router.push({ path: '/Index' })
            },
            // 文档下载
            onDown(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.firstTrialDown,
                    data: {},
                    loading: true,
                    success(res) {
                       window.open(res.data.path)
                    }
                })
            },
            // 文档上传
            uploadFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],i)
                }

                console.log('【that.fil】', that.fil)
            },
            // 上传
            uploadData(pdf,i){
                const that = this
                that.imgData = new FormData()
                // that.imgData.append('catalog','bourse')
                // 
                // that.imgData.append('name','images')
                that.imgData.append('type','pdf')
                that.imgData.append('pdf',pdf)
                that.imgData.append('name',that.user.company_name)
                console.log('*********1',that.imgData)
                that.$request({
                    that: that,
                    api: that.$api.uploadFile,
                    data: that.imgData,
                    headers: { 'content-type': 'multipart/form-data'},
                    discardSign: true,
                    loading: true,
                    success(res){
                        console.log('打印本次结果：',res)
                        // console.log('打印本次上传的图片路径：',res.data)
                        that.supplier_info = res.data.src
                        // console.log('打印查看',that.atlas)
                    },
                    fail(err) {
                        console.log(err)
                        that.$dialog.alert({
                            mes:'上传失败'
                        });
                    }
                })
            },
            // 删除文档重新上传
            onDelete(){
                this.supplier_info = ''
            },
            // 获取审批后详情
            getDetails(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.particulars,
                    data: {},
                    success(res) {
                        if(res.data.supplier_info!=null&&res.data.supplier_info!=''){
                            that.supplier_info = res.data.supplier_info
                        }
                    }
                })
            },
            // 用户信息
            getUser(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.consumer,
                    data: {},
                    success(res) {
                       that.user = res.data
                       that.getRefer()
                    }
                })
            },
            // 参考
            getRefer(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.refer,
                    data: {},
                    success(res) {
                       that.v = res.data
                    }
                })
            },
            // 退出
            onQuit(){
                const that = this
                //存储用户登录凭证
                that.$storage.remove('accesstoken')

                //登录成功发起页面跳转
                that.$dialog.toast({
                    mes: '退出登录成功',
                    timeout: 2000,
                    icon: 'success',
                    callback(){
                        that.$router.push({ path: '/logIn' })
                    }
                })
            },
        },
        mounted() {
            const that = this
            that.$store.commit('EditPageData',this.PageData)
            that.getUser()// 用户信息
            that.isType = that.$route.query.type
            if(that.$route.query.type==2){
                that.getDetails()// 获取审批后详情
            }
        },
        components:{
            
        },
    }
</script>


// WEBPACK FOOTER //
// src/page/submit.vue